import { render, staticRenderFns } from "./VBannerLineDataPatient.vue?vue&type=template&id=0d2ec0d9"
import script from "./VBannerLineDataPatient.vue?vue&type=script&lang=js"
export * from "./VBannerLineDataPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports